import styled, { css } from 'styled-components';

import { ModalHeading } from 'components/modal';
import { primitive } from 'styles/constants/primitives';

import { ModalContent } from '../styled';

type DeliveryOnSameScreen = { $deliveryOnSameScreen?: boolean };

const variantNotOnSameScreenTextFilling = css`
  flex: 1;
  padding: 0;

  ${Styles.desktop} {
    padding: 0 2.5rem;
    flex: 0;
  }
`;

export const Container = styled(ModalContent)<DeliveryOnSameScreen>`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  margin-block-end: 8px;

  ${Styles.desktop} {
    margin-inline-start: ${(props: any) => (props.$deliveryOnSameScreen ? '-7rem' : 'auto')};
  }
`;

export const LoadingText = styled.p<DeliveryOnSameScreen>`
  text-align: center;
  font: var(--font-copyOne);
  padding: 0;
  margin-block-start: 0;
  margin-block-end: ${primitive.$spacing2};
  margin-inline: 0;

  ${Styles.desktop} {
    padding: 0 2.5rem;
  }

  ${({ $deliveryOnSameScreen }) => !$deliveryOnSameScreen && variantNotOnSameScreenTextFilling};
`;

export const LoadingGraphic = styled.img`
  height: 13.75rem;
  margin: 1.875rem;
  justify-self: center;
  ${Styles.desktop} {
    margin: 3.125rem;
  }
`;

export const GraphicTextWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
`;
export const ContainerThirdParties = styled.div`
  width: 100%;
  text-align: center;
`;

export const DeliveryUnavailableHeaderContainer = styled(ModalHeading)`
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-block-end: ${primitive.$spacing7};
  font: var(--font-headerOne);

  svg {
    margin-block-end: 4px;
  }
`;
